import { forEach, includes } from 'lib/helpers';
import _pickBy from 'lodash/pickBy';

import { CRUISING_PORT_CODES, DAY_TYPE_TOUR, LABEL_MISSING_PORT_CODE, PORT_CODE_PREFIX, PORT_VISIT_ACTIVITY_TOURING } from '../constants';

export const getPortCodes = (labels) => {
	let portCodes = {};
	let labelsItems = labels;
	let filterLabels = _pickBy(labelsItems, (value, key) => key.startsWith(PORT_CODE_PREFIX, 0));

	forEach(filterLabels, (value, key) => {
		const portCode = key.replace(PORT_CODE_PREFIX, '');
		portCodes[portCode] = value;
	});

	return portCodes;
};

export const getPorts = (days, portCodes) => {
	const ports = [];
	let previousPortCode = null;

	days.forEach((d) => {
		if (d.type !== DAY_TYPE_TOUR) {
			forEach(d.ports, (p) => {
				if (p.activity !== PORT_VISIT_ACTIVITY_TOURING && p.port && p.port.code !== previousPortCode) {
					let port = p.port;

					if (includes(CRUISING_PORT_CODES, p.port.code))
						port = {
							...port,
							name: portCodes[port.code] || port.code,
							region: null,
						};
					else if (p.port.name && (p.port.name === '' || p.port.name === LABEL_MISSING_PORT_CODE))
						port = {
							...port,
							name: null,
							region: null,
						};
					else if (p.port.region === '')
						port = {
							...port,
							region: null,
						};

					ports.push({
						code: port.code || null,
						name: port.name || null,
						region: port.region || null,
					});

					previousPortCode = port.code;
				}
			});
		}
	});
	return ports;
};
